import { VLayout } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VLayout,{attrs:{"justify-center":""}},[(_vm.isLoading)?_c(VProgressCircular,{staticClass:"progress-circular",attrs:{"indeterminate":"","color":"primary"}}):_vm._e(),_c(VSnackbar,{attrs:{"value":_vm.fileErrorMessage,"color":"error"}},[_c('div',[_vm._v(_vm._s(_vm.fileErrorMessage))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }